<template>
  <div class="ctn" @click.stop="enterEditHandler">
    <el-tooltip :content="customizable ? '点击修改' : '当前快捷键不支持自定义'" placement="top" :open-delay="500" effect="light">
      <div v-if="!editing" class="text" :class="{'customizable': customizable}">{{text}}</div>
    </el-tooltip>
    
    <div v-if="editing" class="editing-ctn">
      <el-tooltip effect="light" content="按下快捷键输入, Enter 确认, Esc 退出编辑" placement="top">
        <div class="text editText" id="editing-hot-key" >
          {{editText}}
          <div class="line" :class="{'line-visible': lineVisible, 'line-hidden': !lineVisible }"></div>
        </div>
      </el-tooltip>
      <el-popconfirm :title="`确定删除 ${text} ?`" @confirm="delHandler">
        <el-tooltip slot="reference" effect="light" :content="`删除 ${text}`" placement="right">
          <div class="el-icon-minus edit-btn" />
        </el-tooltip>
      </el-popconfirm>
    </div>
    
  </div>
</template>

<script>
export default {
  name: "hotKeyBtn",
  props: ["text", "customizable"],
  data() {
    return {
      editing: false,
      editText: "",
      blinkIntervalID: undefined,
      lineVisible: true
    }
  },
  watch: {
    editing: function() {
      let self = this
      setTimeout(() => {
        if (self.editing) {
          self.enterEditing()
        } else {
          self.exitEditing()
        }
      }, 100)
    }
  },
  mounted() {
    // console.log(`${this.text}: customizable: ${this.customizable}`)
    let self = this

    // 收到正在修改快捷键的广播，如果正在修改的快捷键不是当前这个则退出修改状态
    this.env.ui.editingHotKeyAddCallback((editingHotKey) => {
      if (editingHotKey !== self.text) self.editing = false
    })

    // 收到退出快捷键编辑状态通知时移除监听事件
    this.env.ui.editingHotKeyCancelAddCallback(() => { self.editing = false })

    // 如果是新增的组合键, 则直接进入编辑状态
    if (this.text === "") this.editing = true
  },
  beforeDestroy() {
    this.exitEditing()
  },
  methods: {
    enterEditHandler() {
      if (this.customizable) this.editing = true
    },
    blink() {
      let self = this
      this.blinkIntervalID = setInterval(() => {
        console.log("blink")
        self.lineVisible = !self.lineVisible
      }, 500)
    },
    removeBlink() {
      if (this.blinkIntervalID) {
        clearInterval(this.blinkIntervalID)
      }
    },
    exitEditing() {
      let self = this
      console.log("exit editing", self.text)
      self.removeListener()
      self.$emit("editing", false)
      self.removeBlink()
    },
    enterEditing() {
      let self = this
      // 修改前先广播当前修改的快捷键信息，避免同时修改
      console.log("enter editing", self.text)
      self.env.ui.editingHotKey(self.text)
      this.editText = ""
      self.addListener()
      self.$emit("editing", true)
      self.blink()
    },
    addListener() {
      document.addEventListener("keydown", this.keyboardHandler, true)
    },
    keyboardHandler(ev) {
      let self = this
      ev.preventDefault()
      const keyName = ev.key;
      let name = keyName
      // console.log("keyName:", keyName)

      if (keyName === "Escape") {
        self.editing = false
        return
      }

      if (keyName === "Backspace") {
        let words = self.editText.split("+")
        if (words.length < 1) return

        let newText = ""
        for (let i = 0; i < words.length - 1; i++) {
          newText += i === 0 ? words[i] : ("+" + words[i])
        }

        self.editText = newText
        return
      }

      if (keyName === "Enter") {
        this.editing = false
        self.save()
        return
      }

      if (keyName === "Control") name = "Ctrl"
      if (keyName === "Meta") name = "⌘"
      if (keyName.length === 1) {
        if (this.utils.runtime.isDarwin()) {
          // 如果在 macAltMap/macShiftAltMap 的 getKey() 在对应的 map 中如果有对应的字符则返回修改过的键盘上的字符，如果没有对应的字符则返回原字符
          name = self.utils.hotKey.macAltMap.getKey(name)
          name = self.utils.hotKey.macShiftAltMap.getKey(name)
        }
        name = name.toUpperCase()
      }

      console.log("name:", name)
      if (self.editText === "") {
        self.editText = name
      } else {
        self.editText += ("+" + name)
      }
    },
    removeListener() {
      document.removeEventListener("keydown", this.keyboardHandler, true)
    },
    save() {
      console.log("save")
      // updateHotKey(oldCombo, newCombo)
      this.$emit("updateHotKey", this.text, this.editText)
    },
    delHandler() {
      this.$emit('deleteHotKey', this.text)
    }
  },
}
</script>

<style scoped>
.ctn {
  font-size: 0.8em;
  line-height: 1.7em;
}
.customizable {
  cursor: pointer;
}
.text {
  padding: 0 0.5em;
  min-width: 2em;
  min-height: 1.7em;

  border-radius: 3px;
  margin-bottom: 0.2em;
  background-color: rgba(0, 0, 0, 0.08);
}
.editText {
  width: 100%;
  text-decoration: underline;
  cursor: text;
  display: flex;
  justify-content: center;
  align-items: center;
}

.line {
  width: 1px;
  height: 1.3em;
  margin-left: 1px;
}
.line-visible {
  background-color: #ababab;
}
.line-hidden {
  background-color: rgba(0, 0, 0, 0);
}
.editing-ctn {
  display: flex;
  align-items: center;
}

.edit-btn {
  min-width: 1.7em;
  line-height: 1.7em;
  margin-left: 0.2em;
  cursor: pointer;
  border-radius: 3px;
}
.edit-btn:hover {
  background-color: rgba(0, 0, 0, 0.08);
}
.edit-btn:active {
  background-color: rgba(0, 0, 0, 0.16);
}
</style>
